<template lang="html">
  <span class="badge" :class="'size-' + size">
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    size: {
      default: 2,
      type: Number,
    },
  },
};
</script>

<style lang="scss">
span.badge {
  display: inline-block;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
  color: #212529;
  background-color: #f8f9fa;
  font-weight: normal;

  &.primary {
    background-color: color(primary);
    color: #fff;
  }

  &.danger {
    background-color: red;
    color: #fff;
    font-weight: bold;
  }

  &.size-1 {
    padding: 0.25em 0.4em;
    font-size: 0.5;
  }
  &.size-2 {
    padding: 0.25em 0.4em;
    font-size: 0.75em;
  }
  &.size-3 {
    padding: 0.25em 0.4em;
    font-size: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/parts/components/badge.vue